(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('Details-menu-drawer-container');
  if (!root) return;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.menu-drawer__back-button');
    if (!btn) return;
    const openSubs = root.querySelectorAll('#menu-drawer details[open]');
    const lastOpen = openSubs[openSubs.length - 1];
    if (lastOpen) {
      lastOpen.removeAttribute('open');
      lastOpen.closest('details')?.querySelector(':scope > summary')?.focus();
    } else {
      root.removeAttribute('open');
      document.querySelector('summary.header__icon--menu')?.focus();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
